// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"db74d0bc","54":"ee5f5106","423":"941031ea","484":"b1055e37","896":"e6a0231f","964":"25a8f508"}[chunkId] + ".js";
};